import { style } from '@mui/system';
import React from 'react';
import styled from 'styled-components';
import { User } from '../../../context/UserContext';
import { CouponDetail } from './coupon';
import { formatDateToDot } from '../../../func/func';

interface Props {
  couponDetail: CouponDetail;
  onConfirm: () => void;
  onClose: () => void;
}

function PrimiumConfirm({ couponDetail, onConfirm, onClose }: Props) {
  return (
    <Wrapper
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Header>
        <Title>쿠폰 사용</Title>
        <MembershipBox>
          <BadgeBox>
            <Badge>Primium</Badge>
            <span>이용중</span>
          </BadgeBox>
          <MembershipDate>
            {formatDateToDot(couponDetail.plan_start)} ~{' '}
            {formatDateToDot(couponDetail.plan_end)}
          </MembershipDate>
        </MembershipBox>
        <MessageBox>
          <WarningText>
            현재 고객님은 프리미엄 멤버십 이용 중입니다.
          </WarningText>
          <ConfirmText>
            이 쿠폰은 프리미엄 멤버십이 종료되고 사용하길 권장합니다.그래도
            사용하시겠습니까?
          </ConfirmText>
        </MessageBox>
      </Header>
      <ButtonBox>
        <ConfirmButton onClick={onConfirm}>
          그래도 지금 사용할게요
        </ConfirmButton>
        <CloseButton onClick={onClose}>나중에 사용할게요</CloseButton>
      </ButtonBox>
    </Wrapper>
  );
}

export default PrimiumConfirm;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const MembershipBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #e1e2e4;
  padding: 20px 16px;
  gap: 8px;
`;

const BadgeBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  font-family: Paperlogy;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #6507f4;
`;

const Badge = styled.div`
  border-radius: 4px;
  padding: 2px 8px;
  background: linear-gradient(105.88deg, #008aff 0%, #6900f3 100%);
  color: #ffffff;
`;

const MembershipDate = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222;
`;

const MessageBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const WarningText = styled.div`
  font-size: 15px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #d84836;
`;

const ConfirmText = styled.div`
  font-weight: 500;
  font-size: 15px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
`;

const ButtonBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Button = styled.button`
  border-radius: 8px;
  padding: 12px 28px;
  cursor: pointer;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  border: none;
`;

const ConfirmButton = styled(Button)`
  background-color: #008aff;
  color: #fff;
`;

const CloseButton = styled(Button)`
  background-color: #fff;
  color: #222222;
`;
